import { BrowserRouter, Routes, Route } from "react-router-dom";

import HomePage2 from "../HomePage2/HomePage2";
import AboutPage from "../AboutPage/AboutPage";
import TeamSinglePage from "../TeamSinglePage/TeamSinglePage";
import ShopPage from "../ShopPage";
import ProductSinglePage from "../ProductSinglePage";
import BlogPage from "../BlogPage/BlogPage";
import BlogDetailsFull from "../BlogDetailsFull/BlogDetailsFull";
import ServicePage from "../ServicePage/ServicePage";
import ServiceSinglePage from "../ServiceSinglePage/ServiceSinglePage";
import ProjectPageS2 from "../ProjectPageS2/ProjectPageS2";
import ProjectSinglePage from "../ProjectSinglePage/ProjectSinglePage";
import TeamPage from "../TeamPage/TeamPage";
import ContactPage from "../ContactPage/ContactPage";
import TestimonialPage from "../TestimonialPage/TestimonialPage";
import { useEffect, useState } from "react";
import { getProjects } from "../../api/project";

const AllRoute = () => {
  const [projects, setProjects] = useState([]);
  const [loadingProjects, setLoadingProjects] = useState(true);
  const apiUrl = process.env.REACT_APP_PUBLIC_API_URL;

  useEffect(() => {
    getProjects().then((data) => {
      setProjects(data);
      setLoadingProjects(false);
    });
  }, [apiUrl]);

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage2 />} />
          <Route path="about" element={<AboutPage />} />
          <Route path="service" element={<ServicePage />} />
          <Route path="service-single/:id" element={<ServiceSinglePage />} />
          {!loadingProjects && projects.length > 0 && (
            <Route path="project" element={<ProjectPageS2 />} />
          )}
          {!loadingProjects && projects.length > 0 && (
            <Route path="project-single/:id" element={<ProjectSinglePage />} />
          )}
          <Route path="team" element={<TeamPage />} />
          <Route path="team-single/:id" element={<TeamSinglePage />} />
          <Route path="business" element={<TestimonialPage />} />
          <Route path="product" element={<ShopPage />} />
          <Route path="product-single/:id" element={<ProductSinglePage />} />
          <Route path="event-single/:id" element={<BlogDetailsFull />} />
          <Route path="event" element={<BlogPage />} />
          <Route path="contact" element={<ContactPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
};

export default AllRoute;
